import type { CreateSocialPostRequest } from '../types/instagramAutomation.types';

const TIKTOK_CREATE_KEYS = [
    'tiktok_privacy_level',
    'tiktok_allow_comment',
    'tiktok_allow_duet',
    'tiktok_allow_stitch',
    'tiktok_disable_duet',
    'tiktok_disable_stitch',
    'tiktok_disable_comment',
    'tiktok_commercial_content',
    'tiktok_publish_consent_accepted',
    'tiktok_publish_consent_type',
] as const;

/**
 * Backend enum for tiktok_privacy_level rejects null. Non-TikTok creates must omit
 * TikTok fields entirely — do not send null/undefined placeholders.
 */
export function sanitizeCreateSocialPostBody(body: CreateSocialPostRequest): CreateSocialPostRequest {
    if (body.platform === 'tiktok') {
        const next: CreateSocialPostRequest = { ...body };
        if (!next.tiktok_privacy_level) {
            delete next.tiktok_privacy_level;
        }
        return next;
    }

    const next: CreateSocialPostRequest = { ...body };
    for (const key of TIKTOK_CREATE_KEYS) {
        delete next[key];
    }
    return next;
}
